import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class OperationService {
    constructor(private dataTask: DataTaskService) {}

    public getOperation(params: GetOperationParams): Promise<OperationDetails[]> { return this.dataTask.Post(266, params); }
}

export interface GetOperationParams { operation_id: string; }
export interface OperationDetails { unit_no?: string; adjustment_unit_name?: string; }
